export const apiEndpoints = {
  stats: 'https://defistats.gleec.com/api/v3/stats_xyz/atomicdexio',
  coins: 'https://raw.githubusercontent.com/GLEECBTC/coins/master/coins',
};
